import { useCallback, useEffect, useState } from 'react';

export interface DrawerAnimationProps {
  onClose: () => void;
}

export const useDrawerAnimation = ({ onClose }: DrawerAnimationProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, []);

  const handleCloseDrawer = useCallback(() => {
    setIsOpen(false);
    setTimeout(() => onClose(), 200); // Delay to allow transition animation to complete
  }, [onClose]);

  return {
    isOpen,
    onCloseDrawer: handleCloseDrawer
  };
};
